<template>
  <v-combobox
    v-model="content"
    :items="customerList"
    :loading="loading"
    :search-input.sync="search"
    no-filter
    :label="label"
    return-object
    :item-text="itemText"
    :hide-details="error == null || error == ''"
    placeholder=" "
    browser-autocomplete="off"
    @change="customerSelected"
    :error-messages="valid == true ? null : [valid] "
    :disabled="!enabled"
    :append-icon="appendIcon"
    outlined
    dense
    v-bind:style="{width: width}"
    @input.native="onInput"
  >
    <template v-slot:item="data">
      <div>
        <span>
          <p
            style="font-weight: 500; font-size: 14px;"
          >{{data.item.name}}{{ data.item.locked_out ? " &#128274;" : ""}}</p>
        </span>
        <p style="font-size: 12px;">{{data.item.contact_number}}</p>
      </div>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: "SimpleSearchInput",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    appendIcon: String,
    content: String,
    itemText: String,
    label: String,
    errorMessages: Object,
    lookup: Function,
    inputChanged: Function,
    customerList: Array,
    loading: Boolean,
    customerSelected: Function,
    error: String,
    enabled: Boolean,
    width: String
  },
  data() {
    return {
      menu: false,
      required: false,
      search: null
    };
  },
  watch: {
    search(val) {
      // Items have already been loaded
      // if (this.customers.length > 0) return;

      // Items have already been requested
      // if (this.loading) return;

      if (val == null) return;
      if (val.length <= 1) return;

      this.lookup(val);
    }
  },
  computed: {
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    }
  },
  methods: {
    onInput: function(e) {
      console.log(e.srcElement.value);
      this.$emit("input", e.srcElement.value);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
// .small-text-field .v-icon {
//   font-size: 14px !important;
// }
</style>
